export default __webpack_public_path__ + "static/media/anchors-anchoring.b8c44b6c.jpeg";